// extracted by mini-css-extract-plugin
module.exports = {"scrollBarHidden":"allNotifications_scrollBarHidden_TZYMT"};